export default {

    complete: "complete",
    initiate: "initiate",
    callback: "callback"
}